<template>
  <v-dialog
    :value="show"
    :width="type === 'revokeAll' ? 640 : 400"
    @click:outside="cancel"
  >
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text v-if="!!text">
        <div>{{ text }}</div>
        <v-text-field
          v-model="reason"
          :label="$t('instructions.revokeAll.revoke.label')"
          required
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="cancel()">{{
          $t("dialog.cancel")
        }}</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="confirm()"
          :disabled="disabled"
          >{{ action }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    type: String,
    action: String,
    show: Boolean,
    error: Boolean,
  },
  data() {
    return {
      reason: "",
    };
  },
  computed: {
    disabled() {
      return this.reason === "";
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm", {
        reason: this.reason,
      });
      this.resetData();
    },
    cancel() {
      this.$emit("cancel");
      this.resetData();
    },
    resetData() {
      this.reason = "";
    },
  },
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
